import React from 'react';
import Avatar from './Avatar';

export default function HeaderUserInfo({
  avatarUrl,
  username,
  onAvatarClick,
  onMessagesClick,
  onRequestsClick,
  requestCount = 0,
  unreadCount,
  // Which panel is open, so the button that opens it can say so. With the panels' own close button
  // gone (2026-10-18), these ARE the close controls — a toggle that does not look pressed is
  // indistinguishable from a button that did nothing.
  openPanel,
  }) {

  return (
    <div className="header-user-info">
      <div className="header-actions">
        {/* 2026-10-15: Requests had NO entry point on the web. They existed only per-spot, via the
            drawers Map.js opens on a selected spot — so finding out whether anybody had asked for
            your space meant already knowing where it was and clicking it. The phone has had a
            Requests tab all along. */}
        <button
          type="button"
          className={`header-action-btn header-action-btn--requests${openPanel === 'requests' ? ' is-active' : ''}`}
          onClick={onRequestsClick}
          aria-expanded={openPanel === 'requests'}
          aria-label={requestCount > 0 ? `Requests (${requestCount})` : 'Requests'}
        >
          <i className="fas fa-list-check" />
          {requestCount > 0 && <span className="header-action-badge" />}
        </button>
        <button
          type="button"
          className={`header-action-btn header-action-btn--messages${openPanel === 'messages' ? ' is-active' : ''}`}
          onClick={onMessagesClick}
          aria-expanded={openPanel === 'messages'}
          aria-label={openPanel === 'messages' ? 'Close messages' : 'Open messages'}
        >
          <i className="fas fa-envelope" />
          {unreadCount > 0 && <span className="header-action-badge" />}
        </button>
      </div>
      {/* A button, not a div with a click handler: it is a control, and it was unreachable by
          keyboard and invisible to a screen reader. */}
      <button
        type="button"
        className={`header-user-avatar${openPanel === 'profile' ? ' is-active' : ''}`}
        onClick={onAvatarClick}
        aria-expanded={openPanel === 'profile'}
        aria-label={openPanel === 'profile' ? 'Close profile' : 'Open profile'}
      >
        <Avatar username={username} avatarUrl={avatarUrl} size={36} />
      </button>
      <div className="header-welcome-text">Welcome {username}!</div>
    </div>
  );
}
